module.exports = __webpack_public_path__ + "img/local_authority_default.76345e9e.jpg";